var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgPinFilled = function SvgPinFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "pin-filled_svg__fill",
    d: "M18.8 9 15 5.2c-.2-.2-.6-.2-.9 0-.1.1-1.2 1.2-.7 2.7l-1.7 1.7c-1-.3-3.4-.8-5.2 1-.2.2-.2.6 0 .9L9 14.1 5.2 18c-.2.2-.2.6 0 .9.2.1.6.1.8-.1L9.9 15l2.6 2.6c.2.2.6.2.9 0 1.8-1.8 1.3-4.3 1-5.2l1.7-1.7c1.5.4 2.6-.7 2.7-.7.3-.4.3-.7 0-1"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPinFilled);
export default ForwardRef;